class ReportStub {
    id: number;
    name: string;
    order: number;
    type: ReportTypeEnum;
    visibility: VisibilityEnum;

    get icon() {
        switch (this.type) {
            case ReportTypeEnum.Pivot:
                return "pivot_table_chart";
            case ReportTypeEnum.Chart:
                return "bar_chart";
            default:
                return "list_alt";
        }
    }
    get visible() {
        return this.visibility === VisibilityEnum.Normal;
    }

    constructor(data: any) {
        this.id = data.id;
        this.name = data.name;
        this.order = data.order;
        this.type = data.type ?? ReportTypeEnum.Analysis;
        this.visibility = data.visibility ?? VisibilityEnum.Normal;
    }
}